export default "__VITE_PUBLIC_ASSET__74e75571__"